import React from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

import AppTools from 'utils/app/appTools'

const Footer = props => {
  const {
    intl: { formatMessage }
  } = props

  this.formatMessage = formatMessage
  const lang = AppTools.getActualLanguage()

  return (
    <footer className="ork-skeleton__footer">
      <div className="container-fluid">
        <div className="ork-footer">
          <div className="ork-footer__block">
            <span className="ork-footer__copyright">
							&copy;&nbsp;2018-2026{' '}
              <strong>
                <a href={`https://www.orkestra.deusto.es/${lang}`} target="_blank" rel="noopener" className="text-primary">
									Orkestra
                </a>
								&nbsp;
                <br className="visible-md-block" />
                <small>{this.formatMessage(messages.competitivenessBasqueInstitute)}</small>
              </strong>
            </span>
            <i>{this.formatMessage(messages.anInitiativeOf)}</i>
						&nbsp;
            <strong>
              <a href="https://www.deusto.es" taget="_blank" rel="noopener" className="text-primary">
								Deusto
              </a>
            </strong>
          </div>
          <div className="ork-footer__block" dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.spriGroup) }} />
          <div className="ork-footer__block">
            <ul>
              <li>
                <i className="fal fa-envelope fa-lg text-primary" />
								&nbsp;
                <a href="mailto:behatoki@orkestra.deusto.es">behatoki@orkestra.deusto.es</a>
              </li>
              <li>
                <a
                  href={'https://www.orkestra.deusto.es/' + lang + '/' + this.formatMessage(messages.privacy)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {this.formatMessage(messages.privacy)}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default injectIntl(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js